import { takeLatest } from 'redux-saga/effects';

import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.GET_AGENCIES.REQUEST, saga.getAgencies)
    yield takeLatest(ACTION.FETCH_SUGGEST_AGENCIES.REQUEST, saga.fetchSuggestAgencies)
}
